import React, { Component } from "react";
import TIMPSReports from "./Timps/reportfilter";
import SCIMReports from "./sims/reportFilter";
//import { timpsSignalApp } from "../../config/config";
import { versionInfo } from "../MainPage/VersionInfo";
import _ from "lodash";
import { isFraRole } from "../MainPage/UserInfo";

export const TimpsAllReports = [
  { name: "Line Inspection Report", title: "Line Inspection Report", active: true, reportId: "1" },
  { name: "Line Inspection and Repair Report", title: "Line Inspection and Repair Report", active: false, reportId: "18" },
  { name: "Switch Report", title: "Switch Report", active: false, reportId: "2" },
  { name: "Detailed Switch Inspection", title: "Detailed Switch Inspection", active: false, reportId: "3" },
  { name: "Track Disturbance Report", title: "Track Disturbance Report", active: false, reportId: "4" },
  { name: "Yard Inspection Report", title: "Yard Inspection Report", active: false, reportId: "5" },
  { name: "Bridge Inspection Report", title: "Bridge Inspection Report", active: false, reportId: "6" },
  { name: "Inspection of Curves", title: "Inspection of Curves", active: false, reportId: "7" },
  { name: "Turnout Inspection Report", title: "Turnout Inspection Report", active: false, reportId: "8" },
  { name: "Turnout Inspection Report ONR", title: "Detailed Turnout Inspection Report", active: false, reportId: "8" },
  { name: "Switch Inspection Report", title: "Switch Inspection Report", active: false, reportId: "8" },
  { name: "Yard Switch Inspection Report", title: "Detailed Switch Inspection Report", active: false, reportId: "8" },

  { name: "Safety Briefing", title: "Job Briefing", active: false, reportId: "9" },
  { name: "Monthly Turnout Report ONR", title: "Monthly Turnout Inspection Report", active: false, reportId: "10" },
  { name: "Monthly Turnout Report SCFE", title: "Switch Inspection - Monthly Report", active: false, reportId: "10" },
  { name: "Daily Material Usage Report", title: "Daily Material Usage Report", active: false, reportId: "11" },
  { name: "Weld Report", title: "Weld Report", active: false, reportId: "12" },
  { name: "Derail Annual Inspection", title: "Derail Annual Inspection", active: false, reportId: "13" },
  { name: "Detailed Annual Crossing Inspection", title: "Detailed Annual Crossing Inspection", active: false, reportId: "14" },
  { name: "Inert Retarder Report", title: "Inert Retarder Report", active: false, reportId: "15" },
  { name: "Detailed Switch Machine Report", title: "Detailed Switch Machine Report", active: false, reportId: "16" },
  { name: "Change In Curve Report", title: "Change In Curve Report", active: false, reportId: "22" },
  { name: "CWR Maintenance Record", title: "CWR Maintenance Record", active: false, reportId: "23" },
  { name: "CWR Rail Laying Record", title: "CWR Rail Laying Record", active: false, reportId: "17" },
  { name: "ONR - In Service Rail Failure Report", title: "In Service Rail Failure Report", active: false, reportId: "28" },
  { name: "Track Buckle Report", title: "Track Buckle Report", active: false, reportId: "29" },
  { name: "ONR - Ballast Requirements", title: "Ballast Requirements", active: false, reportId: "19" },
  { name: "ONR - Beaver Dams Report", title: "Beaver Dams Report", active: false, reportId: "20" },
  { name: "ONR - Brush Cutting Requirements", title: "Brush Cutting Requirements", active: false, reportId: "21" },
  { name: "ONR - Ditching Report", title: "Ditching Report", active: false, reportId: "24" },
  { name: "ONR - Surface Lining Requirements", title: "Surface Lining Requirements", active: false, reportId: "25" },
  { name: "ONR - Track Tie Requirements", title: "Track Tie Requirements", active: false, reportId: "26" },
  { name: "ONR - Weed Spraying Requirements", title: "Weed Spraying Requirements", active: false, reportId: "27" },
  { name: "ONR - Switch Tie Requirements", title: "Switch Tie Requirements", active: false, reportId: "30" },
  { name: "ETR - Detailed Crossing Report", title: "Detailed Crossing Report", active: false, reportId: "31" },
  { name: "ETR - Monthly Culvert Report", title: "Monthly Culvert Report", active: false, reportId: "32" },
  { name: "Track Violation Report", title: "Track Violation Report", active: false, reportId: "33" },
  { name: "SCFE Joint Bar Fracture Report", title: "Joint Bar Fracture Report", active: false, reportId: "34" },
  { name: "SCFE Record Of Disturbance Report", title: "Record of Disturbance Report", active: false, reportId: "35" },
  { name: "Work Gang Report", title: "Work Gang Report", active: false, reportId: "37" },
];

const fraReports = [{ name: "Line Inspection Report", title: "Line Inspection Report", active: true, reportId: "1" }];

export default class ReportModule extends Component {
  constructor() {
    super();
    this.state = {
      versionLoadedSuccess: false,
    };

    this.defaultReports = isFraRole() ? [...fraReports] : [...TimpsAllReports];
    this.loadVersion(versionInfo, true);
    this.vInfo = null;
  }
  loadVersion(vInfo, initial = false) {
    let timpsSignalApp = vInfo.isSITE() || vInfo.isReVAMP();
    let treportsFeature = vInfo.getFeatureset("timpsReports");
    let treprotsList = treportsFeature && treportsFeature.subset ? treportsFeature.subset : [];

    let sreportsFeature = vInfo.getFeatureset("siteReports");
    let sreprotsList = sreportsFeature && sreportsFeature.subset ? sreportsFeature.subset : [];
    let fraFeatureList = vInfo.getFeatureset("nonFRACodes");
    let nonFraCode = fraFeatureList && fraFeatureList.value ? true : false;

    let defaultReports = this.calculateReportTypes(this.defaultReports, treprotsList);
    let stateObj = {
      timpsSignalApp: timpsSignalApp,
      timpsReports: treprotsList,
      siteReports: sreprotsList,
      nonFraCode: nonFraCode,
      reportTypes: defaultReports.reportTypes,
      defaultActiveReportState: defaultReports.defaultActiveReportState,
      versionLoadedSuccess: vInfo.loaded || !initial,
    };
    if (initial) {
      this.state = stateObj;
    } else {
      this.setState(stateObj);
    }
  }
  calculateReportTypes(defaultReports, tReports) {
    let defaultActiveReportState = {};
    let rList = tReports;
    let reportTypes = [];
    if (defaultReports) {
      reportTypes = defaultReports.filter((rt) => {
        let found = rList.find((r) => r === rt.name);
        if (found) {
          if (rt.active == true) {
            defaultActiveReportState = {
              reportName: rt.name,
              reportTitle: rt.title,
              reportId: rt.reportId,
            };
          }
        }
        return found;
      });
    }
    return { defaultActiveReportState: defaultActiveReportState, reportTypes: reportTypes };
  }

  render() {
    let timpsSignalApp = this.state.timpsSignalApp;
    const { reportTypes, versionLoadedSuccess } = this.state;
    if (!versionLoadedSuccess) return null;
    return (
      <React.Fragment>
        {!timpsSignalApp && (
          <TIMPSReports
            defaultActiveReport={this.state.defaultActiveReportState}
            nonFraCode={this.state.nonFraCode}
            reportTypes={reportTypes}
          />
        )}
        {timpsSignalApp && (
          <SCIMReports
            list={this.state.siteReports}
            nonFraCode={this.state.nonFraCode}
            selectedReport={this.props.location && this.props.location.state}
            history={this.props.history}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reports/index.jsx